import { StyledImageLogo } from '../TheWestHeader.styled'
import { createHeaderLogo, LogoProps } from './createHeaderLogo'

const logoFile = require('./images/masthead-busselton-dunsborough-times.svg')

const props: LogoProps = {
    alt: 'Busselton Dunsborough Times',
    src: logoFile,
    heights: {
        desktop: 82,
        tablet: 70,
        mobile: 50,
    },
    ampInitialSize: {
        width: 618,
        height: 92,
    },
    verticalSpacing: 10,
}

export default createHeaderLogo(StyledImageLogo, props)
